import React, { Component } from 'react'
import { Button, Modal, Popconfirm, Steps } from 'antd'
import KeyTerms from './Form/KeyTerms'
import Compensation from './Form/Compensation'
import WorkingConditions from './Form/WorkingConditions'

const Step = Steps.Step

class WorkOrderModal extends Component {
  render() {
    const {
      submitting,
      contract,
      workOrder,
      visible,
      current,
      type,
      employee,
      submit,
      update,
      updateWorkOrder,
      keyTermsRef,
      workingConditionsRef,
      compensationRef,
      onCancel,
      prev,
      next,
    } = this.props
    const titles = {
      new: 'Create new Work Order',
      edit: 'Update Work Order',
    }
    const submitButton = {
      new: (
        <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
          <Button loading={submitting} type="primary">
            Submit
          </Button>
        </Popconfirm>
      ),
      edit: (
        <Popconfirm title="Sure to Update?" onConfirm={update}>
          <Button loading={submitting} type="primary">
            Update
          </Button>
        </Popconfirm>
      ),
    }
    const steps = [
      {
        title: 'Key Terms',
        content: (
          <KeyTerms
            {...this.props}
            employee={employee}
            ref={keyTermsRef}
            updateWorkOrder={updateWorkOrder}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'keyTerms',
      },
      {
        title: 'Working Conditions',
        content: (
          <WorkingConditions
            {...this.props}
            employee={employee}
            ref={workingConditionsRef}
            updateWorkOrder={updateWorkOrder}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'workingConditions',
      },
      {
        title: 'Compensation',
        content: (
          <Compensation
            {...this.props}
            employee={employee}
            ref={compensationRef}
            updateWorkOrder={updateWorkOrder}
            type={type}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'compensation',
      },
    ]
    return (
      <Modal
        title={titles[type]}
        visible={visible}
        onCancel={onCancel}
        destroyOnClose={true}
        width={1200}
        footer={null}>
        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.key} title={item.title} />
          ))}
        </Steps>
        <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
          {steps[current].content}
        </div>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button style={{ width: '100px' }} type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 &&
            (submitButton[type] || (
              <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
                <Button loading={submitting} type="primary">
                  Submit
                </Button>
              </Popconfirm>
            ))}
        </div>
      </Modal>
    )
  }
}

export default WorkOrderModal
